import { SubmitEventHandler, useId } from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';
import { Checkbox } from '@motorway/mw-highway-code/alpha';

import { ServiceFeeAppliesNotice } from 'Components/transactionFees/ServiceFeeAppliesNotice/ServiceFeeAppliesNotice';

import { SellerConfirmationExperimentProps } from '../SellerConfirmationExperiment.types';

import texts from './AcceptAndConfirmSale.texts.json';

import styles from './AcceptAndConfirm.scss';

const LocalT = new MDText(texts);

type AcceptAndConfirmSaleProps = Pick<SellerConfirmationExperimentProps, 'isServiceFeeEnabled' | 'offer' | 'serviceFeeDetails'> & {
  className?: string;
  loading: boolean;
  onSubmit: SubmitEventHandler<HTMLFormElement>;
};

export const AcceptAndConfirmSale = ({
  className,
  isServiceFeeEnabled,
  loading,
  offer,
  onSubmit,
  serviceFeeDetails,
}: AcceptAndConfirmSaleProps) => {
  const { serviceFee, serviceFeeTiers } = serviceFeeDetails || {};
  const formattedPrice = `£${offer?.closingBid?.value?.toLocaleString() ?? ''}`;
  const checkboxId = useId();

  return <div className={cx(styles.wrapper, className)}>
    <div className={styles.offer}>
      <span className={styles.label}>{LocalT.translate('label')}</span>
      <strong className={styles.value}>{formattedPrice}</strong>
      {isServiceFeeEnabled && serviceFeeTiers && <ServiceFeeAppliesNotice
        feeAmountGBP={serviceFee?.feeAmountGBP}
        label={LocalT.translate('feeLabel') as string}
        serviceFeeTiers={serviceFeeTiers}
        variant="small"
      />}
    </div>
    <form className={styles.form} onSubmit={onSubmit}>
      <Checkbox
        data-thc-checkbox
        formProps={{
          input: {
            required: true,
          },
        }}
        id={checkboxId}
        label={LocalT.translate('checkbox', {
          dealer: offer.closingBid?.dealerContact?.dealer?.name ?? '',
          offer: formattedPrice,
        })}
      />
      <Button
        data-thc-button
        fullWidth
        disabled={loading}
        icon="arrow"
        label={LocalT.translate('cta')}
        loading={loading}
        type="submit"
      />
    </form>
  </div>;
};
